/** Strata cooldown escrow surface — one shared `ICooldown` interface on
 *  both per-market escrow contracts (the `UnstakeCooldown` a base-asset
 *  tranche redeem routes through, and the `ERC20Cooldown` the
 *  collateral-token leg uses). Requests are booked per
 *  `(escrowToken, user)` regardless of which tranche (senior or junior)
 *  they came from; amounts are denominated in the escrowed collateral
 *  token (sUSDe, sNUSD, mHYPER, …), NOT the tranche's `asset()`.
 *
 *  `balanceOf(token, user)` returns the aggregate state; the claim is
 *  `finalize(token, user)` (see calldata-sdk's `strata` savings kind). */
export const StrataCooldownBalanceAbi = [
  {
    name: 'balanceOf',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'token' },
      { type: 'address', name: 'user' },
    ],
    outputs: [
      {
        type: 'tuple',
        name: 'state',
        components: [
          { type: 'uint256', name: 'pending' },
          { type: 'uint256', name: 'claimable' },
          { type: 'uint256', name: 'nextUnlockAt' },
          { type: 'uint256', name: 'nextUnlockAmount' },
          { type: 'uint256', name: 'totalRequests' },
        ],
      },
    ],
  },
] as const
